<p-dialog
  [(visible)]="visible"
  [style]="{ width: '450px' }"
  header="{{ generalTexts.title.label }}"
  [modal]="true"
  styleClass="p-fluid"
  (onHide)="hideDialog()"
>
  <p-fileUpload
    name="file"
    [url]="uploadUrl"
    [customUpload]="true"
    (uploadHandler)="uploadManually($event)"
    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    cancelLabel="{{ generalTexts.cancelBtn.label }}"
    uploadLabel="{{ generalTexts.uploadBtn.label }}"
    chooseLabel="{{ generalTexts.chooseBtn.label }}"
  ></p-fileUpload>
</p-dialog>
